module.exports = __webpack_public_path__ + "img/AP-logo-white.4308fab6.png";